import { render } from "./corntransplant.vue?vue&type=template&id=92b7bdfc"
import script from "./corntransplant.vue?vue&type=script&lang=js"
export * from "./corntransplant.vue?vue&type=script&lang=js"

import "./corntransplant.vue?vue&type=style&index=0&id=92b7bdfc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__